import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { deleteAllCookies } from '../shared/lib/utilities';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss'],
  standalone: false
})
export class FailedComponent {
  constructor(
    private router: Router,
    private authService: MsalService
  ) {}
  login() {
    deleteAllCookies();
    localStorage.clear();
    this.authService.logoutRedirect({
      postLogoutRedirectUri: '/login'
    });
  }
}
